export class SafetyDataContentModel {
    public safetyDataId: number;
    public langId: number;
    public storagePlace: string;
    public storagePrecautions: string;
    public shelfLife: string;
    public productHandling: string;
    public productDisposal: string;
}
